import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

export default function GapAnalysis() {
  const navigate = useNavigate();
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <Box sx={{ backgroundColor: '#1a1a1a', color: 'white',
        py: 2, px: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <IconButton color="inherit"
          onClick={() => navigate(-1)}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h5" fontWeight="bold">
          GAP-analys
        </Typography>
      </Box>
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">
          GAP-analysen byggs – kommer snart!
        </Typography>
      </Box>
    </Box>
  );
}